import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface LoadingSpinnerProps {
  text?: string;
}

// Guide `.spin`: hairline ring with an accent top segment, 1s linear.
const LoadingSpinner: FC<LoadingSpinnerProps> = ({ text }) => {
  const theme = useTheme();
  return (
    <Box sx={{ textAlign: 'center', mt: 'var(--space-loading-offset)' }}>
      <Box
        role="progressbar"
        sx={{
          width: 36,
          height: 36,
          mx: 'auto',
          borderRadius: '50%',
          border: `3.5px solid ${theme.tokens.colors.glassLine}`,
          borderTopColor: theme.tokens.colors.primary,
          animation: 'ug-spin 1s linear infinite',
          '@keyframes ug-spin': {
            to: { transform: 'rotate(360deg)' },
          },
        }}
      />
      {text && (
        <Typography color="primary" variant="body1" sx={{ mt: 1.5 }}>
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
